import "./style.css";
import { tns } from "@/node_modules/tiny-slider/src/tiny-slider";
import "@/node_modules/tiny-slider/dist/tiny-slider.css";

const path = window.location.pathname.replaceAll("/", "");
let activeTab = path !== "our-services" ? path : null;

export default class ServicesTabs {
  static selector = ".services-tabs";

  constructor(block) {
    this.block = block;

    this.startIndex = 0;

    this.navContainer = this.block.querySelector(".services-tabs__arrows");
    this.prevButton = this.block.querySelector(".services-tabs__arrows__prev");
    this.nextButton = this.block.querySelector(".services-tabs__arrows__next");

    this.tabsWrapper = this.block.querySelector(".services-tabs__tabs-wrapper");
    this.tabsInner = this.block.querySelector(".services-tabs ul");

    this.tabs = this.block.querySelectorAll("[data-tab-target]");
  }

  handleTabs = () => {
    this.tabs.forEach((tab) => {
      tab.addEventListener("click", () => {
        tab.classList.add("active");
        activeTab = tab.dataset.tabTarget;
        this.navigate(tab.dataset.tabTarget);
      });
    });

    if (activeTab) {
      Array.from(this.tabs).find((tab, index) => {
        if (tab.dataset.tabTarget === activeTab) {
          this.startIndex = index;
          tab.classList.add("active");
        }
      });
    } else {
      this.tabs[0].classList.add("active");
    }

    const firstTarget = activeTab
      ? document.getElementById(activeTab)
      : document.getElementById(this.tabs[0].dataset.tabTarget);
    firstTarget && firstTarget.classList.add("active");
  };

  handleTabsSlider = () => {
    this.slider = tns({
      container: "#tabs-slider",
      prevButton: this.prevButton,
      nextButton: this.nextButton,
      controlsContainer: this.navContainer,
      slideBy: 1,
      items: 1,
      autoWidth: true,
      gutter: 0,
      loop: false,
      nav: false,
      startIndex: this.startIndex,
      onInit: this.onSliderInit,
      responsive: {
        765: {
          items: 3,
          gutter: 13,
          autoWidth: false,
          fixedWidth: 210,
        },
        870: {
          items: 4,
          fixedWidth: 310,
        },
      },
    });
  };

  onReady() {
    this.prevButton.addEventListener("click", this.handlePrev);
    this.nextButton.addEventListener("click", this.handleNext);

    this.handleTabs();
    this.handleTabsSlider();
  }

  onSliderInit = () => {
    this.handleControls();
  };

  handleControls = () => {
    // don't show arrows when all items are visible
    if (
      this.tabsInner.scrollWidth - this.tabsWrapper.offsetWidth <=
      this.tabs[0].offsetWidth / 10
    ) {
      this.navContainer.style.display = "none";
    } else {
      this.navContainer.style.display = "block";
    }
  };

  handlePrev = () => {
    this.slider.goTo("prev");
  };

  handleNext = () => {
    this.slider.goTo("next");
  };

  navigate = (page) => {
    window.App.navigateTo(
      `${window.location.origin}/${page}/`,
      "#main",
      "#main",
      false,
      {
        exitTransition: () => {},
        enterTransition: () => {},
      }
    );
  };

  onResize() {
    this.handleControls();
  }

  onDestroy() {
    if (this.prevButton) {
      this.prevButton.removeEventListener("click", this.handlePrev);
    }

    if (this.nextButton) {
      this.nextButton.removeEventListener("click", this.handleNext);
    }

    if (this.slider) {
      this.slider.destroy();
    }
  }
}
